import React from 'react'
import './css/services.css'



export default function () {
  return (
    <>
      <div className="container website">
        <div className="row row-cols-3 website-row">
            <div className="col box">
                <div className="box1">
                <div className="image-scroll " >
                    
                </div>
                </div>
                <div className="box2">
                <div className="image-scroll2" >
                
                </div>

                </div>
            </div>
            <div className="col box large">
            <div className="image-scroll-large" >
            
                </div>

            </div>
            <div className="col box">
                <div className="box1">
                <div className="image-scroll4" >
                
                </div>

                </div>
                <div className="box2">
                <div className="image-scroll5" >
                
                </div>

                </div>
            </div>

        </div>
      </div>
    </>
  )
}
